import { memo, useCallback, useState, useEffect, useMemo } from 'react';
import Popover from 'react-bootstrap/Popover';
import { BzPopoverOverlay, BzChip, BzToolTip } from "../../components";
import { Col, Row } from 'react-bootstrap';
import { WATCHLIST_GRID_INDEX, TL_INDEX, SCRIP_INSTRUMENTS } from '../../utils/global_variables';
import { useDispatch, useSelector } from 'react-redux';
import { WATCHLIST_GRID_REF, clickWithOutModifiers, convertDateToSeconds, convertScripResponseWatchlistGrid, convertTouclineIndexToWatchlistGridIndex, getApiExchangeNameFromMktSegId, getChangeInRs, getScripDisplayDescription, isUserIsAGuest, openOrderEntryModal, openOverviewModal, removeExpiriedScrip } from '../../utils/global_functions';
import { handleModal, handleModalData } from '../../redux/actions/modals';
import { getWfhTouchlineLastTick } from '../../redux/actions/wfh';
import { useKeyWithCtrl, useSingleKey, useWFHMessages } from '../../hooks';
import { useLeftClick } from "../../hooks";
import { SIDE_TRAY_EXPAND_PERCENTAGE, FACILITY_NUM } from '../../utils/global_variables';
import DontMissChip from '../DontMiss/DontMissChip';
import { setScripOverviewData } from '../../redux/actions/marketOverview';
import { updateIsBuyOrSell } from '../../redux/actions/orders';
import { toastConfig } from '../../redux/actions/toast';
import { _getScripsInfo, _resetGridFeatures } from '../../controllers/watchlist';
import { setArrScripToBeAdded } from '../../redux/actions/globalSearch';
import { setIsIndicesOverview } from '../../redux/actions/indices';
import { isPopoverOpen } from '../../redux/actions/watchlist';



const WatchlistGridPopover = ({ isDashboardQuickWatchScrolling, setIsSideBar, setIsGlobalSearch, arrRowData, className, isAddtoWatchlist = false, children, handleSelectSpreadOrderModel, setIsExpanded, isExpiry = false, strFutureExpiry, pageCalled, ...props }) => {
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    if (arrRowData?.length > 0) {
        arrRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] = parseFloat(arrRowData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]).toFixed(arrRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]);
    } else { }

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    const dispatch = useDispatch();
    const [showPopover, setShowPopover] = useState(false);
    // Vaibhav Singh: 01-12-23:BT-109089: Holding state defined : Start
    const [holdingInfo, setHoldingInfo] = useState([]);
    // Vaibhav Singh : 01-12-23:BT-109089: Holding state defined: End
    const holdingsScrips = useSelector(state => state.holdings.holdingsScrips);
    const objCFT = useSelector(state => state?.auth?.objCFT);
    //Maaz A : 07-10-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const objLoginSession = useSelector(state => state.auth.objLoginSession);
    //Maaz A : 07-10-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
    const modals = useSelector(state => state?.modals?.modals);
    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End
    const modalData = useSelector(state => state?.modals?.modalData);
    useKeyWithCtrl('delete', (e) => {
        e.preventDefault();
        setShowPopover(false);
    });

    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - Start
    useSingleKey('delete', (e) => {
        if (!modals['ORDER_ENTRY_MODAL']) {
            e.preventDefault();
            setShowPopover(false);
        }
    });
    //Maaz A : 28-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - MCX Issues Fixes - End

    //Ameersha N - This will close the popover when user click f1 when order entry is opned this will close the popover -- Start
    useEffect(() => {
        const handleKeyDown = (event) => {
            if (['F1', 'F2', 'F3', 'F5', 'F6', 'n', 'v', 'V', 'Enter'].includes(event.key)) {
                setShowPopover(false);
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => {

            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    //Ameersha N - This will close the popover when user click f1 when order entry is opned this will close the popover -- End
    //ManasaB : 13-06-2024 : Changed to left click in grid : Start
    const leftClick = useCallback((e) => {
        if (e?.button === 0) {
            setShowPopover(false);
        }
    }, []);
    const [targetElement] = useLeftClick(leftClick);
    //ManasaB : 13-06-2024 : Changed to left click in grid : End
    //Ameersha -- 22-05-2024 -- not to dsiplay popover while scrolling quickwatch from dashboard -- Start
    useEffect(() => {
        if (isDashboardQuickWatchScrolling !== undefined && isDashboardQuickWatchScrolling) {
            setShowPopover(false);
        }
    }, [isDashboardQuickWatchScrolling]);


    const [placement, setPlacement] = useState();


    //Ameersha -- 22-05-2024 -- not to dsiplay popover while scrolling quickwatch from dashboard -- End
    const onContextMenu = (e) => {
        if (!clickWithOutModifiers(e)) {
            return;
        }
        if (props?.node?.rowHeight) {
            const rowHeight = props?.node?.rowHeight;
            const mousePointer = e?.clientY;
            const screenHeight = window?.innerHeight;
            const multiplier = 4;
            const position = mousePointer + rowHeight * multiplier > screenHeight ? 'top' : 'bottom';
            setPlacement(position);
        } else {
            const mousePointer = e?.clientY;
            const screenHeight = window?.innerHeight;
            const position = mousePointer + 150 > screenHeight ? 'top' : 'bottom';
            setPlacement(position);
        }

        // e.preventDefault();
        if (setIsGlobalSearch) {
            setIsGlobalSearch(false);
        } else { }
        setShowPopover(true);
    };
    //AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - Start
    const handleSetAlert = (scrip) => {
        if (setIsExpanded && setIsSideBar) {
            setIsSideBar(false);
            setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); //BT-112513 Closing side menu on right click of grid : ManasaB : 11/07/2023 Functionality modified by Hiral Mam side menu should close on click of options in the pop over grid

        } else { }
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (!isNotExpired) {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
            return;
        }
        setTimeout(() => {
            dispatch(toastConfig({}));
        }, 50);
        _resetGridFeatures(WATCHLIST_GRID_REF);
        setShowPopover(false);
        dispatch(handleModalData({
            AlertData: {
                symbol: scrip[WATCHLIST_GRID_INDEX.SYMBOL],
                exchange: scrip[WATCHLIST_GRID_INDEX.EXCHANGE],
                series: scrip[WATCHLIST_GRID_INDEX.INSTRUMENT]?.substring(0, 2),
                //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - Start
                description: isExpiry ? strFutureExpiry : getScripDisplayDescription(scrip),
                //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - End
                token: scrip[WATCHLIST_GRID_INDEX.TOKEN],
                mktId: scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID],
                mappedMktId: scrip[WATCHLIST_GRID_INDEX.MAPPED_SEGMENT_ID],
                decimalLocator: scrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR],
                decimalLocator_length: scrip[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH],
                exchange_segement: getApiExchangeNameFromMktSegId(scrip[WATCHLIST_GRID_INDEX.SEGMENT_ID]),
                expiryDate: scrip[WATCHLIST_GRID_INDEX.EXPIRYDATE],
                instrument: scrip[WATCHLIST_GRID_INDEX.INSTRUMENT],
            },
            isShowAlerts: true
        }));

        dispatch(handleModal([{ "SET_ALERT_MODAL": true }]));
    };
    //AzeemKhan : 04-07-2023 : BT-107432 -  Breeze - Alerts - End

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    // const setOrderEntryScripPrice = (activeButtonToggleIndex) => {
    //     //Ameersha N : 15-11-2023 :BT-102298 - Breeze - Single Scrip Order entry || Changed from TL_INDEX to WATCHLIST_GRID_INDEX to avoid conflict
    //     const nAskPrice = parseFloat(arrScripData[WATCHLIST_GRID_INDEX.SELL_PRICE]);
    //     const nLTP = parseFloat(arrScripData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]);
    //     const nBidPrice = parseFloat(arrScripData[WATCHLIST_GRID_INDEX.BUY_PRICE]);
    //     if (activeButtonToggleIndex == ORDER_ENTRY_BUTTON_TOGGLE.BUY) {
    //         if (nAskPrice > 0) {
    //             ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(nAskPrice, arrRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));
    //         } else {
    //             ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(nLTP, arrRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));
    //         }
    //     } else {
    //         if (nBidPrice > 0) {
    //             ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(nBidPrice, arrRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));
    //         } else {
    //             ORDER_ENTRY_GRID_REF?.current?.setOrderInputs(curr => ({ ...curr, scripPrice: getToFixedParseFloat(nLTP, arrRowData[WATCHLIST_GRID_INDEX.DECIMAL_LOCATOR_LENGTH]) }));
    //         }
    //     }
    // };

    const handlePlaceOrder = async (nIsBuyOrSell = 0, arrRowData) => {
        await openOrderEntryModal(arrScripData, arrRowData, objLoginSession, null, null, nIsBuyOrSell);
    };
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End

    const onBuySellClick = async (strBuySell) => {
        dispatch(updateIsBuyOrSell(strBuySell));
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (!isNotExpired) {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
            return;
        }
        if (pageCalled) {
            if (arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID] && arrRowData[WATCHLIST_GRID_INDEX.TOKEN]) {
            } else {
                dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Cannot open order entry of following Scrip', }));
                return;
            }
        }
        const scripDataRes = await _getScripsInfo([{ mkt: getApiExchangeNameFromMktSegId(arrRowData[WATCHLIST_GRID_INDEX.SEGMENT_ID]), token: arrRowData[WATCHLIST_GRID_INDEX.TOKEN] }]);
        const scripDataObj = scripDataRes?.data?.objScripsResp?.result;
        const scripData = convertScripResponseWatchlistGrid(scripDataObj);
        const rowData = pageCalled ? scripData[0] : arrRowData;
        setShowPopover(false);
        if (!isUserIsAGuest('buy_sell')) {//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- Start
            //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - Start
            dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': false }]));
            //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - End
            dispatch(toastConfig({}));
            if (setIsExpanded && setIsSideBar) {
                setIsSideBar(false);
                setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; }); //BT-112513 Closing side menu on right click of grid : ManasaB : 11/07/2023 Functionality modified by Hiral Mam side menu should close on click of options in the pop over grid
            } else { }
            _resetGridFeatures(WATCHLIST_GRID_REF);
            const rowData = pageCalled ? scripData[0] : arrRowData;
            if (pageCalled) {
                if (scripData[0][WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                    //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - Start
                    if (objCFT?.MULTILEG) {
                        handleSelectSpreadOrderModel(scripData[0], strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
                        handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1, rowData);
                    }
                    else {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Currently you are not allowed to place orders in Multileg .` }));
                    }
                } else { handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1, rowData); }
                //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - End
            } else {
                if (arrRowData[WATCHLIST_GRID_INDEX?.NSPREAD] === 1) {
                    //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - Start
                    if (objCFT?.MULTILEG) {
                        handleSelectSpreadOrderModel(arrRowData, strBuySell);//Ameersha N : 11-03-2024 : BT-107070 - Breeze - Spread Order entry
                        handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1, rowData);
                    }
                    else {
                        dispatch(toastConfig({ autoDismiss: true, show: true, message: `Currently you are not allowed to place orders in Multileg .` }));
                    }
                    //BT-135024 : Regression - Bug Fixing - Global Search -  : ManasaB : 14-05-2024 - End
                } else { handlePlaceOrder(strBuySell === 'BUY' ? 0 : 1, rowData); }
            }
        } else { }//Ameersha N - 05-03-2024 - BT-1207722 - Breeze -Guest User Privileges -- End


    };

    const handleOverview = useCallback(() => {
        setShowPopover(false);
        const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
        if (isNotExpired) {
            openOverviewModal(pageCalled, arrRowData, setIsExpanded, setIsSideBar, dispatch, modalData);
            dispatch(setIsIndicesOverview(false));
        } else {
            dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
        }
    }, [arrRowData, setIsExpanded, setIsSideBar, dispatch]);

    const handleChart = () => {
        if (!isUserIsAGuest('chart')) {
            setShowPopover(false);
            const isNotExpired = removeExpiriedScrip(convertDateToSeconds(arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE]));
            if (isNotExpired) {
                openOverviewModal(pageCalled, arrRowData, setIsExpanded, setIsSideBar, dispatch, modalData);
                setTimeout(() => {
                    dispatch(handleModal([{ 'MARKET_OVERVIEW_MODAL': true }], true));
                    dispatch(setScripOverviewData(arrRowData));
                    dispatch(handleModalData({ tab: 'analysis' }));
                    dispatch(setIsIndicesOverview(false));
                }, 300);
            } else {
                dispatch(toastConfig({ show: true, autoDismiss: true, timer: 3000, message: 'Selected scrip has expired!', }));
            }
        }
    };


    // scrip live details in overlay - start
    const [arrScripData, setArrScripData] = useState([]);

    const netChangeFormater = useCallback((detail) => {
        //Ameersha N : 15-11-2023 :BT-102298 - Breeze - Single Scrip Order entry || Changed from TL_INDEX to WATCHLIST_GRID_INDEX to avoid conflict
        if (detail[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE] > 0) {
            let netChangeValue = (detail[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);//By HiralK : 06-09-2023 : For Price optimization
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
            // if (netChangeValue > 0) {
            //     netChangeValue = '+' + netChangeValue;
            //     return netChangeValue;
            // } else {
            //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
            return netChangeValue;
            // }
        }
        return (detail[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]);	    //By HiralK : 06-09-2023 : For Price optimization

    }, [arrRowData]);

    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - Start
    const handleArrGridRowData = (segmentId, token, e) => {
        const detail = [...e.detail];
        if (segmentId === detail[TL_INDEX.SEGMENT_ID] && token === detail[TL_INDEX.TOKEN]) {
            //Ameersha N : 15-11-2023 :BT-102298 - Breeze - Single Scrip Order entry || Changed from TL_INDEX to WATCHLIST_GRID_INDEX to avoid conflict --start
            let arrConvertedData = convertTouclineIndexToWatchlistGridIndex(detail);
            setArrScripData([...arrConvertedData]);
            //Ameersha N : 15-11-2023 :BT-102298 - Breeze - Single Scrip Order entry || Changed from TL_INDEX to WATCHLIST_GRID_INDEX to avoid conflict -- End
        }
    };

    // Ameersha N | BT-95888 Create Watchlist Feature start
    useWFHMessages('touchline', (e) => {
        handleArrGridRowData(arrRowData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID], arrRowData?.[WATCHLIST_GRID_INDEX.TOKEN], e);
    });
    // Ameersha N | BT-95888 Create Watchlist Feature end

    // Ameersha N | BT-95888 Create Watchlist Feature start
    useEffect(() => {
        if (arrRowData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]) {
            const objLastTickData = dispatch(getWfhTouchlineLastTick());
            const arrLastTickScripData = objLastTickData[arrRowData?.[WATCHLIST_GRID_INDEX.SEGMENT_ID_TOKEN]];
            if (arrLastTickScripData?.length > 0) {
                //Ameersha N : 15-11-2023 :BT-102298 - Breeze - Single Scrip Order entry || Changed from TL_INDEX to WATCHLIST_GRID_INDEX to avoid conflict --Start

                let arrConvertedData = convertTouclineIndexToWatchlistGridIndex(arrLastTickScripData);
                setArrScripData([...arrConvertedData]);
                //Ameersha N : 15-11-2023 :BT-102298 - Breeze - Single Scrip Order entry || Changed from TL_INDEX to WATCHLIST_GRID_INDEX to avoid conflict --End

            } else {
                //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - Start
                setArrScripData([...arrRowData]);
                //Maaz A : 08-11-2023 : BT-102298 - Breeze - Single Scrip Order entry - NSECDS Bug Fixes - End
            }
        } else { }
    }, [dispatch, arrRowData, netChangeFormater]);
    //Maaz A : 15-06-2023 : BT-102298 - Breeze - Single Scrip Order entry - End
    // Ameersha N | BT-95888 Create Watchlist Feature end
    const WatchlistGridPopoverName = useCallback(() => {
        if (isExpiry) {
            return (<div className='font-regular font-size2 color-subtext'>{strFutureExpiry}</div>);

        } else if ((arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
            arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT])) {
            return (<div className='font-regular font-size2 color-subtext'>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)}  ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]} ${arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]} `}</div>);
        } else if (!arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE] &&
            !arrRowData[WATCHLIST_GRID_INDEX.OPTIONTYPE]) {
            return (<div className='d-flex align-items-center'><div className='font-regular font-size2 color-subtext'>{arrRowData[WATCHLIST_GRID_INDEX.SERIES]}</div></div>);
        }
        else if (arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE] && !arrRowData[WATCHLIST_GRID_INDEX.STRIKEPRICE]) {
            return (
                <div className='font-regular font-size2 color-subtext'>{`${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(0, 2)}  ${arrRowData[WATCHLIST_GRID_INDEX.EXPIRYDATE].slice(2, 5)} ${arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT].slice(0, 3)} `}</div>
            );
        } else {
            return null;
        }
    }, [arrRowData]);
    //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - Start
    const handleAddToWatchlist = () => {
        setShowPopover(false);
        dispatch(setArrScripToBeAdded([arrRowData]));
        dispatch(handleModal([{ 'GLOBAL_SEARCH_ADDSCRIP_MODAL': true }]));
    };
    //AzeemKhan : 25-10-2023 : BT-107249 -  Breeze – Scrip Overview: Futures Tab  - End


    // Ameersha N | BT-95888 Create Watchlist Feature start
    const getHoldingsData = useMemo(() => {
        if (holdingsScrips?.length && arrRowData?.length) {
            //Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed totalfreequantity also updated: Start
            let nIndex = holdingsScrips?.findIndex((eachHolding) => eachHolding?.TOTALFREEQUANTITY !== "0" && eachHolding?.ISIN === arrRowData[WATCHLIST_GRID_INDEX.ISIN_CODE] && arrRowData[WATCHLIST_GRID_INDEX.INSTRUMENT] === SCRIP_INSTRUMENTS.EQUITIES);
            //Vaibhav Singh:16-12-23: BT-107055: ISIN code added fixed totalfreequantity also updated: End
            return nIndex;
        } else { return -1; }
    }, [holdingsScrips, arrRowData]);
    // Ameersha N | BT-95888 Create Watchlist Feature end
    //Vaibhav Singh: 01-12-23:BT-109089: Added holding Logic in popover : Start
    useEffect(() => {
        if (holdingsScrips?.length && arrScripData?.length) {
            if (holdingsScrips[getHoldingsData]?.nBuyAvgPrice && parseFloat(arrScripData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]) !== 0) {
                let arrNetChangePNL = getChangeInRs((arrScripData[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE] * holdingsScrips[getHoldingsData]['TOTALFREEQUANTITY']).toFixed(2), (parseFloat(holdingsScrips[getHoldingsData]?.nBuyAvgPrice) * parseInt(holdingsScrips[getHoldingsData]?.TOTALFREEQUANTITY)).toFixed(2), 2, false, 'uptrend');
                setHoldingInfo(arrNetChangePNL);
            }
        } else {
            setHoldingInfo([]);
        }
    }, [arrScripData]);
    //Vaibhav Singh: 01-12-23:BT-109089: Added holding Logic in popover : End
    useEffect(() => {
        dispatch(isPopoverOpen(showPopover));
    }, [showPopover]);

    const BzPopover = (
        <Popover className='scripdetails-popover'>
            {
                arrRowData?.length > 0 &&
                <>
                    <Popover.Header>
                        <div className='p-2'>
                            <Row className='g-0'>
                                <Col className='justify-content-start align-items-start'>
                                    <Row className='g-0 align-items-start'>
                                        <Col md={7} className='d-flex flex-row align-items-center'>
                                            <div className='font-medium font-size4 color-text float-start me-2'>{arrRowData[WATCHLIST_GRID_INDEX.SYMBOL]}</div>
                                            <div className='chips-wrap'>
                                                <BzChip className='exchange-chip'>{arrRowData[WATCHLIST_GRID_INDEX.EXCHANGE]}</BzChip>
                                            </div>
                                        </Col>
                                        <Col md={5} className='d-flex justify-content-end'>
                                            {
                                                arrScripData?.length > 0
                                                    ?
                                                    <div className='font-medium font-size4 color-text'>{arrScripData?.[WATCHLIST_GRID_INDEX.LAST_TRADE_PRICE]}</div>
                                                    :
                                                    <div className='font-medium font-size4 color-text'>{(0).toFixed(2)}</div>
                                            }
                                        </Col>
                                    </Row>
                                    <Row className='g-0 align-items-start'>
                                        <Col md={7} className='justify-content-start'>
                                            <WatchlistGridPopoverName />
                                        </Col>
                                        <Col md={5} className='d-flex justify-content-end'>
                                            {
                                                arrScripData?.length > 0
                                                    ?
                                                    <>
                                                        <div className={`font-medium font-size2 color-text float-start ${parseFloat(arrScripData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(arrScripData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive'}`}>
                                                            {parseFloat(arrScripData[WATCHLIST_GRID_INDEX.ABSOLUTE_NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(2)}</div>
                                                        <div className={`font-medium font-size2 color-text ms-1 ${parseFloat(arrScripData?.[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) < 0 ? 'color-negative' : parseFloat(arrScripData?.[WATCHLIST_GRID_INDEX.NET_CHANGE_FROM_PRE_CLOSE]) === 0 ? 'color-text' : 'color-positive'}`}>({parseFloat(arrScripData?.[WATCHLIST_GRID_INDEX?.NET_CHANGE_FROM_PRE_CLOSE])?.toFixed(2)}%)</div>
                                                    </>
                                                    :
                                                    <div className={`font-medium font-size2 color-text`}>{(0).toFixed(2)} {(0).toFixed(2)}%</div>
                                            }
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </Popover.Header>
                    <Popover.Body className='d-flex flex-column'>
                        <div className='bdr-top'>
                            <Row className='g-0 p-2'>
                                <Col className='d-flex justify-content-around'>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Overview'}>
                                        <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleOverview}>
                                            <div class="icon-20 icon-eye icon-primary"></div>
                                        </button>
                                    </BzToolTip>

                                    <BzToolTip placement={'bottom'} TooltipMsg={'Chart'}>
                                        <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleChart}>
                                            <div class="icon-20 icon-graph icon-primary"></div>
                                        </button>
                                    </BzToolTip>
                                    {
                                        objCFT.ALERT === FACILITY_NUM.ON && (
                                            <BzToolTip placement={'bottom'} TooltipMsg={'Alert'}>
                                                <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleSetAlert?.bind(this, arrRowData)}>
                                                    <div class="icon-20 icon-alert icon-primary"></div>
                                                </button>
                                            </BzToolTip>
                                        )
                                    }
                                    {isAddtoWatchlist &&
                                        <BzToolTip placement={'bottom'} TooltipMsg={'Add to watchlist'}>
                                            <button className='btn btn-sm btn-outline d-flex align-items-center justify-content-center me-2' onClick={handleAddToWatchlist}>
                                                <div class="icon-20 icon-add-circle icon-primary"></div>
                                            </button>
                                        </BzToolTip>
                                    }
                                    <button data-testid="buy-btn" onClick={() => onBuySellClick('BUY')} className='btn btn-sm btn-positive text-uppercase me-2'>&nbsp;B&nbsp;</button>
                                    <button data-testid="sell-btn" onClick={() => onBuySellClick('SELL')} className='btn btn-sm btn-negative text-uppercase'>&nbsp;S&nbsp;</button>
                                </Col>
                            </Row>
                        </div>
                        <div className='bdr-top'>
                            <div className='px-2 pb-2'>
                                {getHoldingsData >= 0 &&
                                    <Row className='g-0 py-2 cursor-pointer align-items-center'>
                                        <Col className='d-flex'>
                                            <div className='icon-16 icon-portfolio icon-dark'></div>
                                            <div className='font-regular font-size2 color-text ms-2'>{holdingsScrips[getHoldingsData].TOTALFREEQUANTITY}</div>
                                            {(holdingInfo?.length) ?
                                                <div className='d-flex align-items-center ms-2'>
                                                    <div className={`font-regular font-size2 color-text ${holdingInfo[2]}`}>&#8377;{`${Number(holdingInfo[0]).toLocaleString('en-IN', { minimumFractionDigits: 2 })}`}</div>
                                                    <div className={`font-regular font-size2 color-text ms-1 ${holdingInfo[2]}`}>({holdingInfo[1]})</div>
                                                </div>
                                                : null
                                            }
                                        </Col>
                                    </Row>
                                }
                                {
                                    arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS] !== '0' && arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]?.length > 0 &&
                                    <Row className='g-0 py-2 align-items-center'>
                                        <Col className='d-flex'>
                                            <div className='icon-16 icon-dontmiss icon-yellow'></div>
                                            <div className='chips-wrap ms-2'>
                                                <DontMissChip value={arrRowData[WATCHLIST_GRID_INDEX.DONT_MISS]} isShowAllChips />
                                            </div>
                                        </Col>
                                    </Row>
                                }
                            </div>
                        </div>
                    </Popover.Body>
                </>
            }
        </Popover>

    );



    return (
        <BzPopoverOverlay rootClose trigger='click' show={showPopover} onToggle={() => setShowPopover(false)} placement={placement} popover={BzPopover}>
            {/* ManasaB : 13-06-2024 : Changed to left click in grid : Start */}
            <div ref={targetElement} onClick={onContextMenu}>
                {children}
            </div>
            {/* ManasaB : 13-06-2024 : Changed to left click in grid : End */}
        </BzPopoverOverlay>
    );
};

export default memo(WatchlistGridPopover);